import { buildSubjectSlug } from "@/lib/utils/routing";
import { Anchor, Text } from "@mantine/core";
import Link from "next/link";
import React from "react";
import { useFooterStyles } from "../Footer";

export default function FooterNavLinks({
  liveSubjectNames,
}: {
  liveSubjectNames: string[];
}) {
  const links = [
    {
      header: "Subjects",
      links: [
        ...liveSubjectNames.map((subject) => ({
          title: subject,
          link: buildSubjectSlug(subject),
        })),
      ],
    },
    {
      header: "Info",
      links: [
        {
          title: "Blog",
          link: "/blog",
        },
        {
          title: "About",
          link: "/about",
        },
        {
          title: "Team",
          link: "/team",
        },
      ],
    },
    {
      header: "Legal",
      links: [
        {
          title: "Privacy",
          link: "/privacy",
        },
        {
          title: "Terms",
          link: "/terms",
        },
      ],
    },
  ];
  const { classes } = useFooterStyles();
  return (
    <div className={classes.linksWrapper}>
      {links.map((group, indx) => (
        <React.Fragment key={group.header}>
          <Text
            mb={"sm"}
            c="white"
            style={{ gridColumn: indx + 1, gridRow: 1 }}
          >
            {group.header}
          </Text>
          {group.links.map((link, index) => (
            <Anchor
              title={link.title}
              key={link.link}
              href={link.link}
              component={Link}
              c="lightgrey"
              style={{ gridColumn: indx + 1, gridRow: index + 2 }}
              aria-label={link.title}
            >
              {link.title}
            </Anchor>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}
